import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Product } from 'src/app/shared/product.model';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import {Promotion} from "../promotion.model";
import {DeletePromotionComponent} from "../promotions/delete-promotion/delete-promotion.component";
import {AddPromotionComponent} from "../promotions/add-promotion/add-promotion.component";
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-distributor',
    templateUrl: './distributor.component.html',
    styleUrls: ['./distributor.component.scss'],
    standalone: false
})
export class DistributorComponent implements OnInit {
  showSearchProduct: boolean;
  showSearchSub: boolean;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  pageSize = 10;
  subPageSize = 10;
  pageNumber = 1;
  subPageNumber = 1;
  distributorName!: string;
  distributorId!: number;
  userID: any;
  subscribtionList = new Array<any>();
  productsList = new Array<Product>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    pageIndex: number;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    pageIndex: 0
  };

  productSearchValue = "";
  subSearchValue  = "";
  subTotalSize = 0;
  totalSize = 0;
  selected = new FormControl(0);
  imageSrc: string;
  currentTheme: string;
  promotionsList = new Array<Promotion>();
  sponsorPageSize = 10;
  sponsorSearchValue  = "";
  sponsorsTotalSize = 0;
  sponsorPageNumber = 1;
  showSearchSponsor!: boolean;

  constructor(public dialog: MatDialog,
              private route: ActivatedRoute,
              public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private router: Router,
              private exportService: ExportService) {
                this.currentTheme = localStorage.getItem('activeTheme') || 'theme-light';
                this.showSearchProduct = false;
                this.showSearchSub = false;
                this.userID = this.authService.getUserData().id;
                this.route.params.subscribe((params: Params) => {
                  this.distributorName = params.name;
                  this.distributorId = params.id;
                });
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    if (params.pageIndex === "1") {
                      this.selected.setValue(0);
                      this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.pageSize = params.pageSize ? params.pageSize : 10;
                      this.productSearchValue =  params.searchValue ? params.searchValue : "";
                      this.getProducts();
                    } else if (params.pageIndex === "2") {
                      this.selected.setValue(1);
                      this.subPageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.subPageSize = params.pageSize ? params.pageSize : 10;
                      this.subSearchValue =  params.searchValue ? params.searchValue : "";
                      this.getSubscriptions();
                    } else if (params.pageIndex === "3") {
                      this.selected.setValue(2);
                      this.sponsorPageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.sponsorPageSize = params.pageSize ? params.pageSize : 10;
                      this.sponsorSearchValue =  params.searchValue ? params.searchValue : "";
                      this.getPromotions();
                    }else {
                      this.getProducts();
                    }
                  } else {
                    this.getProducts();
                  }
                });
                if (this.currentTheme === 'theme-light') {
                  this.imageSrc = '../../../assets/images/distributor-light.png';
                } else {
                  this.imageSrc = '../../../assets/images/distributor-dark.png';
                }
              }

  ngOnInit(): void {
    this.utils.setTitle('Distributors');
    this.utils.screenTitle.emit({firstTitle: 'Distributors', firstRoute: '/distributors',
      secondTitle: this.distributorName, secondRoute: '/distributors/distributor/' + this.distributorId
       +  '/' + this.distributorName,
    });
    this.searchForm = new FormGroup({
      productSearch: new FormControl(this.productSearchValue),
      subSearch: new FormControl(this.subSearchValue),
      sponsorSearch: new FormControl(this.sponsorSearchValue),
    });

    if (this.productSearchValue) {
      this.showSearchProduct = true;
    }
    if (this.subSearchValue) {
      this.showSearchSub = true;
    }
    if (this.sponsorSearchValue) {
      this.showSearchSponsor = true;
    }
    
    this.searchForm.get('productSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim(); 
      if (newValue === '' && this.productSearchValue !== '') {
        setTimeout(() => this.clearProductSearch(), 0);
      }
    });
    this.searchForm.get('subSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.subSearchValue !== '') {
        setTimeout(() => this.clearSubSearch(), 0);
      }
    });
    this.searchForm.get('sponsorSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.sponsorSearchValue !== '') {
        setTimeout(() => this.clearSponsorSearch(), 0);
      }
    });
  }

  ngDoCheck() {
    if (this.utils.isDarkMode()) {
      this.imageSrc = '../../../assets/images/distributor-dark.png';
    } else {
      this.imageSrc = '../../../assets/images/distributor-light.png';
    }
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  requestAccess(id: any) {

    const payloadd = {
      ProductsIds: [id],
      DistributorId: parseInt(this.distributorId.toString(), 10),
      IsNewProduct: false
    };


  this.dataService.post('ProductAccessRequest/AdminAccessRequest', payloadd).then((data: any) => {
    if (data.statusCode === 200) {
      this.getProducts();
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Request sent successfully',
          type: 'Success',
          message: 'Your request has been sent successfully, thank you!',
          buttonText: 'Ok'
        }
      });
    } else if (data.statusCode === 623) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'Request already sent!',
          buttonText: 'Ok',
          closeDialogRef: true
        }
      });
    }  else {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    }
  });
  }

  truncateName(firstName: string, lastName: string) {
    let fullName = firstName + ' ' + lastName;
    if (fullName.length  > 12) {
      fullName = fullName.slice(0, 12) + '...';
    }
    return fullName;
  }

  onTabChange(event: any){
    this.selected.setValue(event);
    this.pageNumber = 1;
    this.subPageNumber = 1;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: event + 1};
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  handleProductPage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }
  handleSubPage(e: any) {
    this.subPageNumber = e.pageIndex + 1;
    this.subPageSize = e.pageSize;
    this.queryParams = {pageNumber: this.subPageNumber,
      pageSize: this.subPageSize, searchValue: this.subSearchValue, pageIndex: 2};
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  handleProductSearchClick() {
    if (this.showSearchProduct && this.productsList.length > 0) {
      this.doProductSearch();
    } else {
      this.showSearchProduct = true;
    }
  }
  handleSubSearchClick() {
    if (this.showSearchSub && this.subscribtionList.length > 0) {
      this.doSubSearch();
    } else {
      this.showSearchSub = true;
    }
  }

  doProductSearch() {
    let searchInput = this.searchForm.get('productSearch')?.value || '';
    this.productSearchValue = searchInput.trim();
    this.searchForm.get('productSearch')?.setValue(this.productSearchValue, { emitEvent: false });

    if (this.productSearchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
      this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
    }
  }
  doSubSearch() {
    let searchInput = this.searchForm.get('subSearch')?.value || '';
    this.subSearchValue = searchInput.trim();
    this.searchForm.get('subSearch')?.setValue(this.subSearchValue, { emitEvent: false });
    
    if (this.subSearchValue) {
      this.subPageNumber = 1;
      this.queryParams = {pageNumber: this.subPageNumber,
        pageSize: this.subPageSize, searchValue: this.subSearchValue, pageIndex: 2};
      this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
    }
  }

  clearProductSearch() {
    this.showSearchProduct = !this.showSearchProduct;
    this.searchForm.get('productSearch')?.setValue('');
    this.productSearchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.productSearchValue,
      pageIndex: 1
    };
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  clearSubSearch() {
    this.showSearchSub = !this.showSearchSub;
    this.searchForm.get('subSearch')?.setValue('');
    this.subSearchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.subSearchValue,
      pageIndex: 2
    };
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  notAllowedMessage(id: any, name: any) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: name,
        type: 'Warn',
        header: 'Access Request',
        message: 'You need permission to access product details.',
        buttonText: 'cancel',
        numberOfButtons: 2,
        seconButtonText: 'Send request'
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'Send request') {
        this.requestAccess(id);
      }
    });
  }

  onUserImgError(event: any) {
    if (this.utils.isDarkMode()) {
      event.target.src = '../../../assets/images/distributor-dark.png';
    } else {
      event.target.src = '../../../assets/images/distributor-light.png';
    }
}

  openProduct(allowed: boolean, id: any, name: any, isAddedByManufacturer: any) {
    if (isAddedByManufacturer) {

    } else {
      if (!allowed) {
        this.notAllowedMessage(id, name);
      } else {
        this.router.navigate(['/products/product/' + id + '/' + name]);
      }
    }
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/products-dark.png'
        : '../../../assets/images/products-light.png';
    });
  }

  truncateDescription(desc: string) {
    if (desc.length  > 140) {
      desc = desc.slice(0, 140) + '...';
    }
    return desc;
  }

  deleteUser(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'user',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('distributor/DeleteSalesRepresentative/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.subscribtionList.forEach( (users, index) => {
                if (users.id === id) {
                  this.subscribtionList.splice(index, 1);
                  if (this.subscribtionList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.subPageNumber, pageSize: this.subPageSize, searchValue: this.subSearchValue, pageIndex: 2};
                    this.router.navigate(['/distributors/distributor/'], { queryParams: this.queryParams });
                  } else {
                    this.getSubscriptions();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'User deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }


  getSubscriptions() {
    this.dataService.get('distributor/RetrieveSalesRepresentatives/' +
    parseInt(this.distributorId.toString(), 10) + '?pageNumber=' + this.subPageNumber +
    '&pageSize=' + this.subPageSize +
    '&searchKeyword=' + this.subSearchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.subscribtionList = [];
        const subscriptionsData = data.data.records;
        this.subTotalSize = data.data.count;
        subscriptionsData.forEach((subscriptionData: any) => {
          // const subscriptionInstance = new Subscription(subscriptionData);
          this.subscribtionList.push(subscriptionData);
        });
        if (subscriptionsData.length === 0 && this.subTotalSize > 0) {
          this.subPageNumber = 1;
          this.queryParams = {pageNumber: this.subPageNumber,
            pageSize: this.subPageSize, searchValue: this.subSearchValue, pageIndex: 2};
          this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName],
          { queryParams: this.queryParams });
        }
      }
    });
  }

  getProducts() {
    this.dataService.get('product/RetrieveallProducts/' +
    parseInt(this.distributorId.toString(), 10) + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.productSearchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        const productsData = data.data.records;
        this.totalSize = data.data.count;
        productsData.forEach((productData: any) => {
          this.productsList.push(productData);
        });
        if (productsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber,
            pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
          this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName],
          { queryParams: this.queryParams });
        }
      }
    });
  }

  handleSponsorsPage(e: any) {
    this.sponsorPageNumber = e.pageIndex + 1;
    this.sponsorPageSize = e.pageSize;
    this.queryParams = {pageNumber: this.sponsorPageNumber,
      pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 3};
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  handleSponsorSearchClick() {
    if (this.showSearchSponsor && this.promotionsList.length > 0) {
      this.doSponsorSearch();
    } else {
      this.showSearchSponsor = true;
    }
  }

  doSponsorSearch() {
    let searchInput = this.searchForm.get('sponsorSearch')?.value || '';
    this.sponsorSearchValue = searchInput.trim();
    this.searchForm.get('sponsorSearch')?.setValue(this.sponsorSearchValue, { emitEvent: false });

    if (this.sponsorSearchValue) {
      this.sponsorPageNumber = 1;
      this.queryParams = {pageNumber: this.sponsorPageNumber,
        pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 3};
      this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
    }
  }

  clearSponsorSearch() {
    this.showSearchSponsor = !this.showSearchSponsor;
    this.searchForm.get('sponsorSearch')?.setValue('');
    this.sponsorSearchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.sponsorSearchValue,
      pageIndex: 3
    };
    this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName], { queryParams: this.queryParams });
  }

  getPromotions() {
    this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/' +
      parseInt(this.distributorId.toString(), 10) + '?pageNumber=' + this.sponsorPageNumber +
      '&pageSize=' + this.sponsorPageSize +
      '&searchKeyword=' + this.sponsorSearchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.promotionsList = [];
        const promotionsData = data.data.records;
        this.sponsorsTotalSize = data.data.count;
        promotionsData.forEach((promotionData: any) => {
          const promotionInstance = new Promotion(promotionData);
          this.promotionsList.push(promotionInstance);
        });
        if (promotionsData.length === 0 && this.sponsorsTotalSize > 0) {
          this.sponsorPageNumber = 1;
          this.queryParams = {pageNumber: this.sponsorPageNumber,
            pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 3};
          this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName],
            { queryParams: this.queryParams });
        }
      }
    });
  }


  openAddPromotion() {
    const dialogRef = this.dialog.open(AddPromotionComponent, {disableClose: true, width: '400px',
      data:{userID:this.distributorId}
    });
    dialogRef.afterClosed().subscribe((newPromotions) => {
      if (newPromotions.length > 0) {
        this.getPromotions();
      }
    });
  }

  deletePromotion(id: any, code: any) {
    const dialogRef = this.dialog.open(DeletePromotionComponent, {
      disableClose: true,
      width: '400px',
      data: {
        id,
        code
      }});
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'delete') {
        this.promotionsList.forEach( (promotion, index) => {
          if (promotion.id === id) {
            this.promotionsList.splice(index, 1);
            if (this.promotionsList.length === 0 && this.pageNumber > 1){
              this.queryParams = {pageNumber: this.sponsorPageNumber,
                pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 3};
              this.router.navigate(['/distributors/distributor/' + this.distributorId + '/' + this.distributorName],
                { queryParams: this.queryParams });
            } else {
              this.getPromotions();
            }
          }
        });
      }
    });
  }

  exportDistributerProducts(fileTypeId: number) {
    this.exportService.exportFile(`product/ExportAllProducts/${this.distributorId}`, fileTypeId, this.productSearchValue, 'distributerProducts');
  }

  exportDistributerSubscriptions(fileTypeId: number) {
    this.exportService.exportFile(`distributor/ExportSalesRepresentatives/${this.distributorId}`, fileTypeId, this.subSearchValue, 'distributerSubscriptions');
  }

  exportDistributerPromotions(fileTypeId: number) {
    this.exportService.exportFile(`promotionCode/export/PromotionCodeByUserId/${this.distributorId}`, fileTypeId, this.sponsorSearchValue, 'distributerPromotions');
  }

}
